import { AccesTLR } from './acces-tlr.entity';
import { LocalDateTime } from '../../../../shared/jsr310-localdates/types/local-date-time.type';

export class OperationCarl {
	
	refOperationCarl!: string;
	idOuvrage!: number;
	nomOuvrage!: string;
	refOuvrageDansCarl!: string;
	classeOuvrage!: string;
	acte!: string;
	intitule!: string;
	dateDebut!: LocalDateTime;
	dateFin!: LocalDateTime;
	statut!: string;
	alreadyBound: boolean = false;
	idActe!: number;
	otherAccesBoundToThis: AccesTLR[] = [];
	
	styleStatut: string = '';
	libelleStatut: string = '';
	libelleDate: string = '';
	
	constructor(idOuvrage: number, acte: string, dateDebut: LocalDateTime, idActe: number) {
		this.idOuvrage = idOuvrage;
		this.acte = acte;
		this.dateDebut = dateDebut;
		this.statut = 'INIT';
		this.idActe = idActe;
	}
	
}